<div class="header-fixed-container {{helpersService.notWizard ? 'py-4' : 'pt-4'}} px-2">
    <div class="row gx-0 justify-content-center">
        <div class="col-5 d-flex align-items-center">
            <span *ngIf="helpersService.arrowIcon" (click)="back()" class="d-block icp-arrow-left icp-icon-24 cursor-pointer"></span>
        </div>
        <div class="col-2 d-flex align-items-center justify-content-center">
            <a *ngIf="helpersService.navLogo" routerLink="/dashboard/home">
                <div class="icp-logo-positive icp-icon-40"></div>
            </a>
            <div *ngIf="!helpersService.navLogo" class="icp-logo-positive icp-icon-40"></div>
        </div>
        <div class="col-5 d-flex align-items-center justify-content-end">
            <div class="d-flex flex-column position-relative user-select-none">
                <div *ngIf="helpersService.languages.length && helpersService.headerLangClicked" class="language-select">
                    <ng-container *ngFor="let lang of helpersService.languages; let i = index">
                        <div (click)="helpersService.searchSelectedLanguage(lang.value)" class="cursor-pointer" [class.pb-1]="i < helpersService.languages.length - 1">{{LANGUAGE_PREFIX + lang.value.replace("_", "-") | translate}}</div>
                    </ng-container>
                </div>
                <div class="c-red mb-1 cursor-pointer fw-bold">
                    @if(helpersService.languages.length && helpersService.headerLang?.stateCode) {
                        <span (click)="helpersService.headerLangClicked = !helpersService.headerLangClicked" class="language-select-button">{{helpersService.headerLang.value.split("_")[0].toUpperCase()}}</span>
                    }
                    @if(!helpersService.notHelp) {
                        <span class="px-2">|</span>
                        <span (click)="swalNSP()">{{"menu-help" | translate}}</span>
                    }
                    @if(helpersService.storageAccessToken) {
                        <span class="px-2">|</span>
                        <span (click)="helpersService.logoutIAM()">{{"dashboard-logout" | translate}}</span>
                    }
                </div>
                <div *ngIf="!helpersService.notHelp && waitHelp" class="c-red mb-1 cursor-pointer fw-bold">
                    <span *ngIf="helpersService.languages.length && helpersService.headerLang?.stateCode" (click)="helpersService.headerLangClicked = !helpersService.headerLangClicked" class="language-select-button">{{helpersService.headerLang.value.split("_")[0].toUpperCase()}}</span><span *ngIf="helpersService.languages.length && helpersService.headerLang?.stateCode" class="px-2">|</span>
                    <span class="c-grey6">{{"menu-help" | translate}}</span>
                    <span *ngIf="helpersService.storageAccessToken" class="px-2">|</span><span *ngIf="helpersService.storageAccessToken" (click)="helpersService.logoutIAM()">{{"dashboard-logout" | translate}}</span>
                </div>
                <div *ngIf="helpersService.bell" class="icp-icon-40 icp-notification-new"></div>
            </div>
        </div>
    </div>
    <div *ngIf="!helpersService.notWizard" style="margin-bottom: -2px">
        <vfa-cp-wizard></vfa-cp-wizard>
    </div>
</div>